import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'EmpyreanLiquidity';

  ngOnInit() {
    const path = window.location.pathname;
    // if (path !== '/signin-oidc') {
    //   if (!this.openIdConnectService.userAvailable) {
    //     this.openIdConnectService.triggerSignIn();
    //   }
    // }
  }
}
